import { createSlice } from '@reduxjs/toolkit';
// import { createLoadingSlice } from '@store/loadingSlice';
import {
  CONTRACTOR_LOS_PATH,
  modeOfTransportApi,
} from '@store/rtk/modeOfTransport';
import { TableData } from '@uikit/Tables/types';
import { DEFAULT_PAGE_SIZE } from '@src/utils/constants';
import { TABLE_COLUMNS } from '@uikit/Tables/columns';

const initialState: {
  modeOfTransportTableData: TableData;
  singleModeOfTransport: any;
} = {
  modeOfTransportTableData: {
    columns: [],
    rows: [],
    size: 5,
  },
  singleModeOfTransport: null,
};

const getRequestedTableData = ({
  payload,
  meta,
  fallbackSize,
}: {
  payload: any;
  meta: any;
  fallbackSize?: number;
}) => {
  const params = meta.arg.originalArgs?.params || {};
  const resetSizeToDefault =
    meta.arg.originalArgs?.argument?.resetSizeToDefault ||
    meta.arg.originalArgs?.resetSizeToDefault;
  const pathName =
    meta.arg.originalArgs?.argument?.pathName ??
    meta.arg.originalArgs?.pathName;
  const page =
    typeof params.page === 'number' ? params.page : payload.page || 0;
  const size =
    typeof params.size === 'number'
      ? params.size
      : resetSizeToDefault
        ? payload.size || DEFAULT_PAGE_SIZE
        : fallbackSize || payload.size || DEFAULT_PAGE_SIZE;
  const totalElements = payload.totalElements ?? payload.content.length;
  const isContractorLos = pathName === CONTRACTOR_LOS_PATH;
  const contractorLosContent =
    isContractorLos && payload.content.length > size
      ? payload.content.slice(page * size, page * size + size)
      : payload.content;

  return {
    page,
    size,
    totalElements,
    totalPages: isContractorLos
      ? Math.ceil(totalElements / size)
      : payload.totalPages,
    content: isContractorLos ? contractorLosContent : payload.content,
  };
};

export const modeOfTransportSlice = createSlice({
  name: 'modeOfTransport',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addMatcher(
        modeOfTransportApi.endpoints.getModeOfTransportTableData.matchFulfilled,
        (state, { payload, meta }) => {
          if (payload.content && Array.isArray(payload.content)) {
            const { payorModeOfTransportColumns, modeOfTransportColumns } =
              TABLE_COLUMNS;
            const requestedTableData = getRequestedTableData({
              payload,
              meta,
              fallbackSize: state.modeOfTransportTableData.size,
            });

            state.modeOfTransportTableData = {
              ...state.modeOfTransportTableData,
              columns:
                payload.table === 'payorModeOfTransport'
                  ? payorModeOfTransportColumns
                  : modeOfTransportColumns,
              rows: [
                ...requestedTableData.content.map((el, idx) => ({
                  ...el,
                  loadDuration:
                    el?.loadDuration?.split(':').slice(0, 2).join(':') || '',
                  unloadDuration:
                    el?.unloadDuration?.split(':').slice(0, 2).join(':') || '',
                  id: el.id ? el.id : idx,
                  authRequired: Boolean(el?.authRequired) ? 'Yes' : 'No',
                })),
              ],
              ...payload,
              page: requestedTableData.page,
              size: requestedTableData.size,
              totalElements: requestedTableData.totalElements,
              totalPages: requestedTableData.totalPages,
              requestTablePageChange:
                modeOfTransportApi.endpoints.getModeOfTransportTableData,
            };
          } else {
            state.modeOfTransportTableData.rows = payload;
          }
        }
      )

      .addMatcher(
        modeOfTransportApi.endpoints.getSingleModeOfTransport.matchFulfilled,
        (state, { payload }) => {
          state.singleModeOfTransport = payload;
        }
      );
  },
});

export const selectModeOfTransport = (state) => state.modeOfTransport;
export const modeOfTransportReducer = modeOfTransportSlice.reducer;
